export default {
  names: ['place', 'folio'],
  encode() {
    const key = 'isPlaceSearch';
    const val = 'Y';

    return [key, val];
  },
};
